import { action, Action, computed, Computed } from 'easy-peasy';
import { ServiceCheck, ServiceCheckPayload } from '~/types';

interface ChecksDataPayload {
    checks: ServiceCheck[]
}

export interface ServiceCheckModel {
    fetching: boolean
    setFetching: Action<ServiceCheckModel, boolean>

    checksData: ServiceCheckPayload[]

    currentCheck: ServiceCheckPayload | null
    updateCurrentCheck: Action<ServiceCheckModel, ServiceCheckPayload | null>

    loadChecksData: Action<ServiceCheckModel, ChecksDataPayload>
    updateCheckData: Action<ServiceCheckModel, ServiceCheckPayload>
    isChecksDataUpdated: Computed<ServiceCheckModel>
}

export const serviceCheckModel: ServiceCheckModel = {
    fetching: false,
    setFetching: action((state, payload) => {
        state.fetching = payload;
    }),

    checksData: [],

    currentCheck: null,
    updateCurrentCheck: action((state, check) => {
        state.currentCheck = check;
    }),

    loadChecksData: action((state, data) => {
        state.checksData = [];
        data.checks.map(check => state.checksData.push({
            ...check
        }))
    }),
    updateCheckData: action((state, check) => {
        state.checksData = state.checksData.map(item => item.id === check.id ? check : item);
    }),
    isChecksDataUpdated: computed(state => state.checksData.every(check => check.isServiceSection === true || check.status !== null) ? true : false),
};
